import { createApp } from 'vue/dist/vue.esm-bundler';
import HpEvents from './HpEvents.vue';

const mountEl = document.querySelector('[data-app-hp-events-list]');

if ( mountEl )
{
    createApp(HpEvents, { 
        ...mountEl.dataset 
    }).mount(mountEl);
}